"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = Thead;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react2 = require("@chakra-ui/react");

var _Tr = _interopRequireDefault(require("./Tr"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// deps
// components
function Thead(props) {
  const {
    children,
    ...otherProps
  } = props;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react2.Thead, { ...otherProps,
    children: /*#__PURE__*/(0, _react.isValidElement)(children) && _react.Children.toArray(children).map(function (child) {
      if (_Tr.default === (child == null ? void 0 : child.type)) {
        return /*#__PURE__*/(0, _react.cloneElement)(child, {
          isHeading: true
        });
      } else {
        return child;
      }
    })
  });
}

Thead.propTypes = {
  children: _propTypes.default.node
};